import React, {useState, useEffect, useCallback} from 'react';
import {Language} from 'models/language';
import {useAccountStore} from './account-store';
import {createHook, createProvider, ProviderProps} from 'utils';

import {agent} from 'core/api';

function getLastSelected() {
    const id = localStorage.getItem('target-language');
    if (id) return Number(id);
}

function setLastSelected(id: number) {
    return localStorage.setItem('target-language', id.toString());
}

export type Languages = ReturnType<typeof useLanguageSelectorStore>;

function useLanguageSelectorStore() {
    const [list, setList] = useState<Language[]>([]);
    const [mother, setMother] = useState<Language>();
    const [target, setTarget] = useState<Language>();
    const [loading, setLoading] = useState(true);

    const accountStore = useAccountStore();

    const selectTarget = (lang: Language) => {
        setTarget(lang);
        setLastSelected(lang.id);
    };

    const init = useCallback(async () => {
        const list: Language[] = await agent.languages.getAll();
        const mother = list.find(el => el.subdomain === 'www');

        let target;

        if (accountStore.hasRole('moderator', 'admin', 'super_admin')) {
            const lastTargetId = getLastSelected();
            if (lastTargetId) {
                target = list.find(el => el.id === lastTargetId);
            }

        } else {
            if (accountStore.account?.translator) {
                const languageId = accountStore.account.translator.assignedLanguageId;
                target = list.find(el => el.id === languageId);
            }
        }

        if (!target) target = mother;

        setList(list);
        setMother(mother);
        setTarget(target);
        setLoading(false);
    }, [accountStore]);

    useEffect(() => {
        if (accountStore.loggedIn) {
            init().then();
        }
    }, [init, accountStore]);

    return {
        list,
        mother,
        target,
        loading,
        selectTarget,
    };
}

const Context = React.createContext<Languages | null>(null);

export const LanguagesProvider = (props: ProviderProps) => {
    const languages = useLanguageSelectorStore();
    return createProvider(Context, languages, props);
};
export const useLanguages = createHook(Context, 'Language Selector');